import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { GridSelection } from '../interfaces/grid-selection';

@Injectable({
  providedIn: 'root',
})
export class SiaWidgetDataService {
  private _selectionChanged: Subject<GridSelection> = new Subject();

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  selectionChanged(value: GridSelection) {
    this._selectionChanged.next(value);
  }

  get selectionChanged$(): Observable<GridSelection> {
    return this._selectionChanged.asObservable();
  }
}
